import React from 'react';

const Arrow = () => {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.5 2V41M21.5 41L2 22.28M21.5 41L41 22.28" stroke="#EDEDED" stroke-width="3.75" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default Arrow;